import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { detectUtmSourceParam } from "@/stores/EngineStore/helpers/detectUtmSourceParam.ts";
import { useEffect } from "react";

const PHOBS_NOISE_PARAMS = ["object", "date", "nights", "phobs_skin", "undefined"];

export const useUtmSourceURLParam = () => {
  const setUtmSource = useEngineStore((s) => s.setUtmSource);
  useEffect(() => {
    setUtmSource(detectUtmSourceParam());

    const params = new URLSearchParams(window.location.search);
    let changed = false;
    for (const key of PHOBS_NOISE_PARAMS) {
      if (params.has(key)) {
        params.delete(key);
        changed = true;
      }
    }
    if (changed) {
      const qs = params.toString();
      const newUrl = qs ? `?${qs}` : window.location.pathname;
      window.history.replaceState(window.history.state, "", newUrl);
    }
  }, [setUtmSource]);
};
